(() => {
  const DEBUG = true;

  const gridSel = '#product-grid';
  const nextBtnSel = 'a.js-pagination__next-button';

  const log = (...a) => DEBUG && console.log('[B2B Show More]', ...a);

  const getGrid = (doc = document) => doc.querySelector(gridSel);
  const getNextBtn = (doc = document) => doc.querySelector(nextBtnSel);

  function safeCall(label, fn) {
    if (typeof fn !== 'function') return false;
    try {
      fn();
      log('ran:', label);
      return true;
    } catch (e) {
      console.warn('[B2B Show More] error in', label, e);
      return false;
    }
  }

  function b2bReinitPass(passLabel) {
    const b = window.B2BRIDGE;
    if (!b) return log('No B2BRIDGE on window');

    log(`Reinit pass: ${passLabel}`);

    // Core init hooks you actually have
    safeCall('B2BRIDGE.initLitComponent', () => b.initLitComponent?.());
    safeCall('B2BRIDGE.initLockHide', () => b.initLockHide?.());
    safeCall('B2BRIDGE.initQuoteRule', () => b.initQuoteRule?.());
    safeCall('B2BRIDGE.initialize', () => b.initialize?.());

    // Collection hooks (you proved collections.refresh exists)
    safeCall('B2BRIDGE.collections.refresh', () => b.collections?.refresh?.());
    safeCall('B2BRIDGE.collections.init', () => b.collections?.init?.());
    safeCall('B2BRIDGE.collections.initialize', () => b.collections?.initialize?.());
    safeCall('B2BRIDGE.collection.refresh', () => b.collection?.refresh?.());
    safeCall('B2BRIDGE.collection.init', () => b.collection?.init?.());
    safeCall('B2BRIDGE.collection.initialize', () => b.collection?.initialize?.());

    // Modules you actually have
    const mods = b.modules || {};
    for (const [name, mod] of Object.entries(mods)) {
      if (!mod) continue;
      safeCall(`modules.${name}.refresh`, () => mod.refresh?.());
      safeCall(`modules.${name}.init`, () => mod.init?.());
      safeCall(`modules.${name}.initialize`, () => mod.initialize?.());
      safeCall(`modules.${name}.render`, () => mod.render?.());
    }

    // Theme events some apps hook into
    document.dispatchEvent(new CustomEvent('facet:rendered'));
    document.dispatchEvent(new CustomEvent('shopify:section:load'));
    document.dispatchEvent(new CustomEvent('shopify:section:reorder'));
  }

  function b2bReinitAfterAppend() {
    b2bReinitPass('immediate');
    setTimeout(() => b2bReinitPass('after 300ms'), 300);
    setTimeout(() => b2bReinitPass('after 1200ms'), 1200);
  }

  async function loadNextPage(btn) {
    const grid = getGrid();
    if (!grid) return log('No #product-grid found');

    const href = btn.getAttribute('href');
    if (!href) return log('No href on next button');

    log('Fetching', href);

    btn.setAttribute('aria-busy', 'true');
    const originalText = btn.textContent;
    btn.textContent = 'LOADING…';

    try {
      const res = await fetch(href, { credentials: 'same-origin' });
      log('Fetch status', res.status);
      if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const nextGrid = getGrid(doc);
      if (!nextGrid) throw new Error('Next page has no #product-grid');

      const newItems = Array.from(nextGrid.querySelectorAll(':scope > li.grid__item, :scope > li'));
      log('Append candidates:', newItems.length);

      newItems.forEach(li => grid.appendChild(li));
      log('Items appended:', newItems.length);
      log('Grid items now:', grid.querySelectorAll('li').length);

      const nextBtn = getNextBtn(doc);
      if (nextBtn?.getAttribute('href')) {
        btn.setAttribute('href', nextBtn.getAttribute('href'));
        log('Next href updated to', btn.getAttribute('href'));
        btn.textContent = originalText;
        btn.removeAttribute('aria-busy');
      } else {
        log('No further pages. Removing button.');
        btn.remove();
      }

      // Key part: force B2B to re-run whatever it can
      b2bReinitAfterAppend();

    } catch (err) {
      console.error('[B2B Show More] failed:', err);
      btn.textContent = originalText;
      btn.removeAttribute('aria-busy');
    }
  }

  function onClick(e) {
    const btn = e.target.closest(nextBtnSel);
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    loadNextPage(btn);
  }

  document.addEventListener('click', onClick, true);
  log('Listener attached for', nextBtnSel);
})();